/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_RealitymixInputs */

const cs_enum_realitymix = /** @type {(inputs: Enum_RealitymixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RealityMIX`)
};

const en_enum_realitymix = /** @type {(inputs: Enum_RealitymixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RealityMIX`)
};

/**
* | output |
* | --- |
* | "RealityMIX" |
*
* @param {Enum_RealitymixInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_realitymix = /** @type {((inputs?: Enum_RealitymixInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_RealitymixInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_realitymix(inputs)
	return cs_enum_realitymix(inputs)
});